export default "__VITE_PUBLIC_ASSET__04e5514b__"